import { createColumnHelper } from '@tanstack/react-table'
import { NavLink } from 'react-router-dom'
import type { FuelReportDetails } from '../../../../../../types'
import { formatCurrency } from '../../../utils/formatCurrency'
import { formatNumber } from '../../../utils/formatNumber'
import { ReportTextCell } from '../../ReportTextCell'

type DataProps = {
  options: { year: string; month: string }
}

const settings = {
  digits: {
    min: 0,
    max: 0,
  },
}

export default function fuelReportDetailsColumns({ options }: DataProps) {
  const columnHelper = createColumnHelper<FuelReportDetails>()
  return [
    columnHelper.accessor('regNo', {
      id: 'regNo',
      enableSorting: false,
      header: 'Reg.nr.',
      cell: ({ row, getValue }) => (
        <NavLink
          className="flex w-fit text-interaction hover:underline hover:text-interactionHover"
          to={`/reports/fuel/${options.year}-${options.month}/${row.original.accountNo}?regNo=${encodeURIComponent(
            String(getValue()),
          )}&consolidatedAgreementID=${encodeURIComponent(String(row.original.consolidatedInvoiceAgreement))}`}
        >
          {getValue()}
        </NavLink>
      ),
    }),
    columnHelper.accessor('vehicleId', {
      id: 'vehicleId',
      enableSorting: false,
      header: 'Kjøretøy-ID',
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('invoiceGroupingDescription', {
      id: 'invoiceGroupingDescription',
      header: 'Fakturagruppe',
      cell: (row) => <ReportTextCell value={row.getValue()} />,
    }),
    columnHelper.accessor('carDescription', {
      id: 'carDescription',
      enableSorting: false,
      header: 'Objekt',
      cell: (row) => <ReportTextCell value={row.getValue()} />,
    }),
    columnHelper.accessor('driverName', {
      id: 'driverName',
      enableSorting: false,
      meta: { alignmentType: 'string' },
      header: 'Sjåfør',
      cell: (row) => <ReportTextCell value={row.getValue()} />,
    }),
    columnHelper.accessor('amountIncVat', {
      id: 'amountIncVat',
      meta: {
        mobileFooterLabel: 'Sum beløp',
        alignmentType: 'right',
      },
      header: 'Beløp',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('amountIncVat') as number) || 0), 0)
        return formatCurrency(total)
      },
      cell: (row) => formatCurrency(row.getValue()) || '',
    }),
    columnHelper.accessor('volume', {
      id: 'volume',
      sortingFn: 'alphanumeric',
      meta: {
        mobileFooterLabel: 'Totalt mengde',
        alignmentType: 'right',
      },
      header: 'Mengde',
      cell: (row) => formatNumber(row.getValue(), settings) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('volume') as number) || 0), 0)
        return formatNumber(total, settings)
      },
    }),
  ]
}
